import React from 'react';
import ItemRevisionModel from '../../../models/ItemRevisionModel';
import BillOfMaterials from '../Components/BillOfMaterials';

interface IProps {
    itemRevision: ItemRevisionModel
    refreshCounter: number
}

const ItemRevision_tab_BillOfMaterials: React.FC<IProps> = ({ itemRevision, refreshCounter }) => {
    return <>
        {itemRevision.defaultBomId !== undefined && <BillOfMaterials id={itemRevision.defaultBomId} />}
    </>
}
export default ItemRevision_tab_BillOfMaterials;